import { pushRecentSite } from "@/utils/navPrefs";

// selectedRestaurant je samo za prikaz (naziv u traci); state.restaurant je stvarni radni kontekst koji čitaju
// sve restoranske stranice (finansije, meni...) - moraju se mijenjati zajedno, inače izbor ne utiče na podatke.
// Isto radi i stari SitesDropdown.
export function selectSite(store, site) {
  if (!site) return;
  store.commit("SET_SELECTED_RESTAURANT", site);
  store.commit("SAVE_RESTAURANT", site);
  pushRecentSite(site.id);
}

// Jezik iz trake: isto što i LanguageSelector (pamti izbor i postavlja pismo).
export function applyLocale(vm, code) {
  vm.$i18n.locale = code;
  localStorage.setItem("restorani-lang", code);
  if (code === "rs-lat" || code === "sr-lat" || code === "hr") {
    vm.$store.state.isLatin = 0;
    vm.$store.commit("SAVE_LANGUAGE", 1 - vm.$store.state.isLatin);
  }
  if (code === "rs" || code === "sr") {
    vm.$store.state.isLatin = 1;
    vm.$store.commit("SAVE_LANGUAGE", 1 - vm.$store.state.isLatin);
  }
  vm.$emit("set-lang");
}
